var _a;
import { __assign } from "tslib";
import { IMAGE_FORMATS, IMAGE_SIZE_FOLDERS, IMAGE_SIZE_SCALE, } from "../constants";
var EXPORTS_PATH = "exports";
var DEFAULT_RETURN_URL = (_a = {},
    _a[IMAGE_SIZE_SCALE.preview] = "",
    _a[IMAGE_SIZE_SCALE.original] = "",
    _a);
var getSplitUrl = function (url) {
    var originalFormat = url.split(".").pop() || "";
    var path = url.split(".".concat(originalFormat)).shift() || "";
    var sourceUrl = path.split("/".concat(EXPORTS_PATH)).shift() || "";
    var fileName = path.split("/").pop() || "";
    return { sourceUrl: sourceUrl, fileName: fileName, originalFormat: originalFormat };
};
export var getUrlsInSupportedFormat = function (_a) {
    var url = _a.url, isSupportWebp = _a.isSupportWebp;
    if (!url) {
        return DEFAULT_RETURN_URL;
    }
    var _b = getSplitUrl(url), sourceUrl = _b.sourceUrl, fileName = _b.fileName, originalFormat = _b.originalFormat;
    var format = isSupportWebp ? IMAGE_FORMATS.webp : originalFormat;
    if (!sourceUrl || !fileName || !format) {
        return DEFAULT_RETURN_URL;
    }
    var correctSizeUrl = function (size) {
        return isSupportWebp ? "".concat(size, "_").concat(IMAGE_FORMATS.webp) : size;
    };
    return Object.values(IMAGE_SIZE_SCALE).reduce(function (acc, size) {
        var _a;
        var sizeFolder = correctSizeUrl(IMAGE_SIZE_FOLDERS[size]);
        return __assign(__assign({}, acc), (_a = {}, _a[size] = "".concat(sourceUrl, "/").concat(EXPORTS_PATH, "/").concat(sizeFolder, "/").concat(fileName, ".").concat(format), _a));
    }, DEFAULT_RETURN_URL);
};
